import React, { useState } from 'react';
import { Lock } from 'lucide-react';
import { useBloqueo } from '../../context/BloqueoContext';

/** Interruptor de «Bloquear con Face ID». Solo aparece en la app con biometría. */
export const BloqueoBiometrico: React.FC = () => {
  const { disponible, nombreBiometria, activo, activar, desactivar } = useBloqueo();
  const [ocupado, setOcupado] = useState(false);
  const [error, setError] = useState('');

  if (!disponible) return null;

  const cambiar = async () => {
    setError(''); setOcupado(true);
    try { await (activo ? desactivar() : activar()); }
    catch { setError(`No se ha podido comprobar ${nombreBiometria}.`); }
    finally { setOcupado(false); }
  };

  return (
    <div className="border-t border-gray-100 dark:border-gray-700 pt-5">
      <div className="flex items-center gap-3">
        <Lock className="w-5 h-5 text-gray-500 dark:text-gray-400 shrink-0" />
        <div className="flex-1">
          <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-300">Bloquear con {nombreBiometria}</h3>
          <p className="text-xs text-gray-400 dark:text-gray-500">
            Pide {nombreBiometria} al abrir la app y al volver a ella tras un minuto. Si reinstalas la app o entras en otro iPhone, te preguntaremos si activarlo.
          </p>
        </div>
        <button role="switch" aria-checked={activo} onClick={cambiar} disabled={ocupado}
          className={`relative w-12 h-7 rounded-full transition shrink-0 disabled:opacity-50 ${
            activo ? 'bg-blue-600' : 'bg-gray-300 dark:bg-gray-600'}`}>
          <span className={`absolute top-0.5 left-0.5 w-6 h-6 rounded-full bg-white shadow transition-transform ${
            activo ? 'translate-x-5' : ''}`} />
        </button>
      </div>
      {error && <p className="text-xs text-red-600 dark:text-red-400 mt-2">{error}</p>}
    </div>
  );
};
